<script setup lang="ts">
import { IonApp, IonRouterOutlet } from "@ionic/vue";

import ReloadPrompt from "@/components/ReloadPrompt.vue";
</script>

<template>
  <IonApp>
    <IonRouterOutlet />
    <ReloadPrompt />
  </IonApp>
</template>
